import React, { useEffect, useState } from "react";
import { Typography, Box, useTheme, Skeleton } from "@mui/material";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { useParams } from "react-router-dom";
import { useGetMonthlyFatalitiesQuery } from "store/slices/apis/safetyDashboardSlice";
import SafetyPopup from "./SafetyPopup";

const MissIncidenteGraph = () => {
    const theme = useTheme();
    const { projectId } = useParams();
    const [popupData, setPopupData] = useState(null);
    const [open, setOpen] = useState(false);
    const { data, isLoading } = useGetMonthlyFatalitiesQuery({ projectId, year: "2025" });
    const [chartData, setChartData] = useState({
        categories: [],
        series: [],
    });
    useEffect(() => {
        if (data?.data && Array.isArray(data?.data)) {
            const categories = data?.data?.map(item => item?.month);
            const series = data?.data.map(item => ({
                y: item?.count,
                color: "#CB402D",
            }));
            setChartData({ categories, series });
        }
    }, [data]);
    const options = {
        chart: {
            type: 'column',
            height: 300,
            borderRadius: "50%"
        },
        title: {
            text: null,
        },
        xAxis: {
            categories: chartData?.categories,
            crosshair: true,
            labels: {
                style: {
                    fontSize: '12px',
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: null,
            },
            labels: {
                format: '{value}',
            },
        },
        plotOptions: {
            column: {
                borderRadius: 0,
                pointPadding: 0,
                borderWidth: 0,
                minPointLength: 5
            }
        },
        series: [
            {
                name: 'Progress',
                data: chartData?.series,
                cursor: 'pointer',
                point: {
                    events: {
                        click: function () {
                            setPopupData({
                                category: data?.data?.map((item) => item.month)[this.x],
                                value: this.y,
                            });
                            setOpen(true);
                        },
                    },
                },
            }
        ],
        credits: {
            enabled: false,
        },
        legend: {
            enabled: false,
        },
    };

    const getDateRangeFromMonthString = (monthStr) => {
        const monthMap = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11, };

        const monthName = monthStr.slice(0, 3);
        const yearSuffix = monthStr.slice(4);
        const year = parseInt('20' + yearSuffix);

        const monthIndex = monthMap[monthName];

        const startDate = new Date(year, monthIndex, 1); // ist day of month
        const endDate = new Date(year, monthIndex + 1, 0); // last day of month

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            dateRange: formatDate(startDate) + ',' + formatDate(endDate),
        };
    };

    return (

        <Box sx={{ backgroundColor: "white", marginTop: "10px", border: "1px solid #D8D8D8", borderRadius: "12px" }}>
            <Box sx={{ margin: '0 auto', p: 2 }}>
                <Typography variant="h6" sx={{ mb: 1, color: `${theme?.customSettings?.themeColor}`, fontWeight: "500", fontSize: '18px', paddingTop: "20px", lineHeight: "100%", letterSpacing: "0.4px" }}>
                    Fatalities
                </Typography>
                <Typography variant="body2" sx={{ mb: 2, color: "#182A4E80" }}>
                    Track and evaluate fatality data to ensure compliance with safety standards and mitigate critical project risks
                </Typography>
            </Box>
            <Typography style={{ marginTop: "40px", paddingLeft: "10px" }}>
                {isLoading ? (
                    <Skeleton variant="rectangular" height={300} animation="wave" />
                ) : chartData?.categories?.length === 0 ? (
                    <Box sx={{ height: 300, display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <Typography sx={{ fontSize: "16px", color: "#999", fontWeight: 500 }}>
                            No data available to display the chart.
                        </Typography>
                    </Box>
                ) : (
                    <HighchartsReact highcharts={Highcharts} options={options} />
                )}
            </Typography>
            {open && (() => {
                const { dateRange } = getDateRangeFromMonthString(popupData.category);
                return (
                    <SafetyPopup title={'Fatalities'} value={dateRange} status={'dateRange'} onOpen={open} onClose={() => setOpen(false)} />
                )
            })()}
        </Box>
    );
};

export default MissIncidenteGraph;